import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FiArrowUpRight, FiCheck } from "react-icons/fi";
import PageHeader from "../components/PageHeader";
import services from "../data/services";
import "./Services.css";

const process = [
  {
    num: "01",
    title: "Enquiry & sampling",
    body: "Share your target market, volume, and quality brief. We send samples from the current harvest within 48 hours.",
  },
  {
    num: "02",
    title: "Sourcing & grading",
    body: "We source from known growing belts, clean and grade to your specification, and share photographs and lab reports.",
  },
  {
    num: "03",
    title: "Packing & labelling",
    body: "Bulk sacks, retail packs, or private label — packed under food-grade conditions with buyer-approved markings.",
  },
  {
    num: "04",
    title: "Documentation",
    body: "Phytosanitary, fumigation, Certificate of Origin, FSSAI, APEDA — every paper ready before the container is loaded.",
  },
  {
    num: "05",
    title: "Freight & tracking",
    body: "We book, stuff, and dispatch via our preferred lines from Mundra, Kandla, Nhava Sheva, or JNPT. Live tracking throughout.",
  },
  {
    num: "06",
    title: "Destination support",
    body: "We stay on the line until your cargo clears customs at destination — and follow up after, because the next order matters.",
  },
];

function Services() {
  return (
    <motion.main
      className="page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4 }}
    >
      <PageHeader
        eyebrow="What we do"
        title="Trade and logistics, <em>under one roof.</em>"
        subtitle="A single team handles sourcing, grading, packing, paperwork, and freight. That's not just convenient — it's how nothing gets lost between the field and the buyer's door."
      />

      <section className="section">
        <div className="container">
          <div className="services-grid">
            {services.map((s, i) => {
              const Icon = s.icon;
              return (
                <motion.div
                  key={s.title}
                  className="service-box"
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.55, delay: i * 0.05 }}
                >
                  <div className="service-box__top">
                    <div className="service-box__icon">
                      <Icon />
                    </div>
                    <span className="service-box__num">0{i + 1}</span>
                  </div>
                  <h3>{s.title}</h3>
                  <p>{s.summary}</p>
                  <ul>
                    {s.points.map((pt) => (
                      <li key={pt}>
                        <FiCheck /> {pt}
                      </li>
                    ))}
                  </ul>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Process timeline */}
      <section className="section services-process">
        <div className="container">
          <div className="section-head">
            <div>
              <span className="eyebrow">How we work</span>
              <h2>Six steps, <em>one accountable team.</em></h2>
            </div>
          </div>

          <div className="process-timeline">
            {process.map((p, i) => (
              <motion.div
                key={p.num}
                className="process-step"
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
              >
                <span className="process-step__num">{p.num}</span>
                <div className="process-step__body">
                  <h3>{p.title}</h3>
                  <p>{p.body}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="cta-band">
        <div className="container cta-band__inner">
          <h2>
            Ready to brief a shipment? <br />
            <em>Tell us what you need.</em>
          </h2>
          <Link to="/contact" className="btn btn-primary">
            Talk to our team <FiArrowUpRight />
          </Link>
        </div>
      </section>
    </motion.main>
  );
}

export default Services;
